import { UserFilterGroup } from '@/entities/filter/ui/FilterSelects';
import {
  REGISTRATION_STATUS_LABEL,
  type RegistrationStatus,
} from '@/entities/prescription-registration/api/prescription-registration.api';
import { FilterDrawer, FilterGroup } from '@/shared/ui';

export interface PrescriptionsFilter {
  userIds?: number[];
  /** 없으면 전체(등록 + 미등록) */
  registrationStatus?: RegistrationStatus;
}

interface PrescriptionsFilterDraft {
  userIds?: number[];
  registrationStatus?: string[];
}

const REGISTRATION_STATUS_OPTIONS = (
  ['REGISTERED', 'UNREGISTERED'] as const
).map((status) => ({
  value: status,
  label: REGISTRATION_STATUS_LABEL[status],
}));

/** 체크 상태 → URL 값. 하나만 고르면 그 값, 둘 다·없음은 전체 */
const fromStatusChecks = (
  checks: string[] | undefined,
): RegistrationStatus | undefined => {
  if (checks?.length !== 1) return undefined;
  return checks[0] === 'UNREGISTERED' ? 'UNREGISTERED' : 'REGISTERED';
};

interface PrescriptionsFilterDrawerProps {
  open: boolean;
  value: PrescriptionsFilter;
  onClose: () => void;
  onApply: (filter: PrescriptionsFilter) => void;
}

/** 07 처방 등록 현황 필터 — 담당자 · 등록 상태 (다중 선택) */
export function PrescriptionsFilterDrawer({
  open,
  value,
  onClose,
  onApply,
}: PrescriptionsFilterDrawerProps) {
  const draftValue: PrescriptionsFilterDraft = {
    userIds: value.userIds,
    registrationStatus: value.registrationStatus
      ? [value.registrationStatus]
      : undefined,
  };

  return (
    <FilterDrawer
      open={open}
      value={draftValue}
      onClose={onClose}
      onApply={(draft) =>
        onApply({
          // 아무도 안 고르면 전체
          userIds: draft.userIds?.length ? draft.userIds : undefined,
          registrationStatus: fromStatusChecks(draft.registrationStatus),
        })
      }
    >
      {(draft, patch) => (
        <>
          <UserFilterGroup
            value={draft.userIds}
            onChange={(userIds) => patch({ userIds })}
          />
          <FilterGroup
            title="등록 상태"
            value={draft.registrationStatus}
            options={REGISTRATION_STATUS_OPTIONS}
            onChange={(registrationStatus) => patch({ registrationStatus })}
          />
        </>
      )}
    </FilterDrawer>
  );
}
